/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */
import React from 'react';

import './CarbonDescriptionField.scss';

function CarbonDescriptionField(props) {
    const { id, description } = props;
    return <div id={id} className="baiw--form-description-field">{description}</div>;
}

export { CarbonDescriptionField };